import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGroup = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.14001 9.85999C7.14001 9.44577 7.4758 9.10999 7.89001 9.10999H8.92001C9.33423 9.10999 9.67001 9.44577 9.67001 9.85999C9.67001 10.2742 9.33423 10.61 8.92001 10.61H7.89001C7.4758 10.61 7.14001 10.2742 7.14001 9.85999Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 9.10999C11.5858 9.10999 11.25 9.44577 11.25 9.85999C11.25 10.2742 11.5858 10.61 12 10.61H16.11C16.5242 10.61 16.86 10.2742 16.86 9.85999C16.86 9.44577 16.5242 9.10999 16.11 9.10999H12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.14001 14C7.14001 13.5858 7.4758 13.25 7.89001 13.25H8.92001C9.33423 13.25 9.67001 13.5858 9.67001 14C9.67001 14.4142 9.33423 14.75 8.92001 14.75H7.89001C7.4758 14.75 7.14001 14.4142 7.14001 14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 13.25C11.5858 13.25 11.25 13.5858 11.25 14C11.25 14.4142 11.5858 14.75 12 14.75H16.11C16.5242 14.75 16.86 14.4142 16.86 14C16.86 13.5858 16.5242 13.25 16.11 13.25H12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.25 6.00324C3.25 4.38965 4.70504 3.25 6.28888 3.25H17.7111C19.295 3.25 20.75 4.38965 20.75 6.00324V18.0043C20.7339 19.6078 19.2889 20.75 17.7111 20.75H6.28888C4.70504 20.75 3.25 19.6104 3.25 17.9968V6.00324ZM6.28888 4.75C5.3394 4.75 4.75 5.39965 4.75 6.00324V17.9968C4.75 18.6003 5.3394 19.25 6.28888 19.25H17.7111C18.6428 19.25 19.2418 18.6051 19.25 17.9925V6.00324C19.25 5.39965 18.6606 4.75 17.7111 4.75H6.28888Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconGroup as ReactComponent };
